__turbopack_context__.v({
  "city": "styles-module__ui_rUa__city",
  "cityContainer": "styles-module__ui_rUa__cityContainer",
  "heading": "styles-module__ui_rUa__heading",
  "link": "styles-module__ui_rUa__link",
  "serviceType": "styles-module__ui_rUa__serviceType",
  "title": "styles-module__ui_rUa__title",
});
